// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uzeym{--icon-color: var(--white);position:fixed;top:0;left:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;z-index:1400}.uzeym>.yzMvm{width:inherit;height:inherit;background-color:#000;opacity:.3;position:absolute}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"globalLoader": `uzeym`,
	"overlay": `yzMvm`
};
export default ___CSS_LOADER_EXPORT___;
